export default "__VITE_ASSET__ipmJMK3i__"